<template>
  <ContentCard
    title="Our Mobile App is Live!"
    description="The mobile app is free for all users. Download now to get started."
    :requiredRoles="[]"
    :padded="true"
    :showPrimary="false"
    primaryLabel=""
    primaryRoute=""
    :showSecondary="true"
    secondaryLabel="Download Here"
    :secondaryRoute="appStoreLink" />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import ContentCard from '@/components/ComponentLibrary/ContentCard.vue';

const appStoreLink = computed(() => {
  const ua = navigator.userAgent || navigator.vendor || '';
  const isAndroid = /android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);

  if (isAndroid) {
    return 'https://play.google.com/store/search?q=squashlevels&c=apps';
  }

  if (isIOS) {
    return 'https://apps.apple.com/us/app/squashlevels/id6743806671';
  }

  return 'https://app.squashlevels.com/';
});
</script>
